import { IEntityUpdate } from '@/interfaces'

export class EntityUpdate implements IEntityUpdate {
	entityId: string
	entityName: string
	entityField: string
	entityValue: any

	constructor(entity: IEntityUpdate) {
		this.entityId = entity.entityId.toString()
		this.entityName = entity.entityName
		this.entityValue = entity.entityValue
		this.entityField = entity.entityField
	}
}